import React from "react";
import { Box, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import EditIcon from "@icons/myicons/edit.svg?react";
import DeleteIcon from "@icons/myicons/trash-delete-bin-2.svg?react";

type Props = {
  onEditClick: () => void;
  onDeleteClick: () => void;
  handleCloseMenu?: () => void;
};

export const ActionMenu = ({
  onEditClick,
  onDeleteClick,
  handleCloseMenu,
}: Props) => {
  const { t } = useTranslation();
  const handleEditClick = () => {
    onEditClick();
    handleCloseMenu?.();
  };

  const handleDeleteClick = () => {
    onDeleteClick();
    handleCloseMenu?.();
  };

  return (
    <>
      <MenuItem onClick={handleEditClick} data-testid="edit-menu-item">
        <Box display="flex" alignItems="center" gap={3}>
          <EditIcon width={20} height={20} />
          <Typography variant="body3">{t("csvImport.edit")}</Typography>
        </Box>
      </MenuItem>
      <MenuItem onClick={handleDeleteClick}>
        <Box display="flex" alignItems="center" gap={3} color="error.main">
          <DeleteIcon />
          <Typography variant="body3">{t("csvImport.delete")}</Typography>
        </Box>
      </MenuItem>
    </>
  );
};
